import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadConfig } from "./config";
import "./styles.css";

function configureRouteMetadata(): void {
  if (!/^\/d\/[^/]+$/.test(window.location.pathname)) return;

  document.title = "Secure file download — DropJet";

  const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  description?.setAttribute(
    "content",
    "Retrieve a private, time-limited file shared through DropJet.",
  );

  const robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  robots?.setAttribute("content", "noindex, nofollow, noarchive");
}

async function main(): Promise<void> {
  configureRouteMetadata();
  await loadConfig();
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing root element");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void main().catch((error: unknown) => {
  document.body.innerHTML = `<main class="fatal"><h1>DropJet could not start</h1><p>${
    error instanceof Error ? error.message : "Unknown configuration error"
  }</p></main>`;
});
